var map = {
	"./assets/thewest-digital-hero-cropped.jpg": 618,
	"./assets/thewest-digital-hero-variation-a-cropped.jpg": 619,
	"./assets/thewest-digital-hero-variation-a.jpg": 893,
	"./assets/thewest-digital-hero-variation-b-cropped.jpg": 620,
	"./assets/thewest-digital-hero-variation-b.jpg": 894,
	"./assets/thewest-digital-hero-variation-black-friday-cropped.jpg": 621,
	"./assets/thewest-digital-hero-variation-black-friday.jpg": 895,
	"./assets/thewest-digital-hero-variation-eofy-mobile.jpg": 461,
	"./assets/thewest-digital-hero-variation-eofy.jpg": 896,
	"./assets/thewest-digital-hero-variation-experiment2-cropped.jpg": 622,
	"./assets/thewest-digital-hero-variation-experiment2.jpg": 897,
	"./assets/thewest-digital-hero-variation-footy-lives-here-guernsey.jpg": 898,
	"./assets/thewest-digital-hero-variation-footy-lives-here-mobile-guernsey.jpg": 623,
	"./assets/thewest-digital-hero-variation-footy-lives-here-mobile.jpg": 462,
	"./assets/thewest-digital-hero-variation-footy-lives-here.jpg": 899,
	"./assets/thewest-digital-hero-variation-summer-of-cricket-mobile.jpg": 463,
	"./assets/thewest-digital-hero-variation-summer-of-cricket.jpg": 900,
	"./assets/thewest-digital-hero-variation-vanishing-cousins-cropped.jpg": 624,
	"./assets/thewest-digital-hero-variation-vanishing-cousins.jpg": 901,
	"./assets/thewest-digital-hero.jpg": 902
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2977;